'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var backLink = require('./back-link-0ede7a09.js');
var styles$j = require('./styles-4395bd12.js');

var BackButton = function (_a) {
    var onPressBack = _a.onPressBack, toggle = _a.toggle, _b = _a.backButtonVariant, backButtonVariant = _b === void 0 ? 'chevron' : _b, _c = _a.backButtonText, backButtonText = _c === void 0 ? 'Back' : _c;
    var handleKey = React.useCallback(function () { var _a; return (_a = onPressBack === null || onPressBack === void 0 ? void 0 : onPressBack()) !== null && _a !== void 0 ? _a : toggle(); }, [onPressBack, toggle]);
    var handleOnBackKeyDown = React.useCallback(function (e) {
        e.stopPropagation();
        var isKeyValid = e.keyCode === 13 || e.keyCode === 32;
        return isKeyValid ? handleKey() : undefined;
    }, [handleKey]);
    return (React__default.createElement(styles$j.BackButtonContainer, { onClick: onPressBack || undefined, className: "back-button-container" }, backButtonVariant === 'chevron' ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(styles$j.BackIcon, { "data-testid": "modal-wrapper-back-button", role: "button", tabIndex: 0, onKeyDown: handleOnBackKeyDown }),
        React__default.createElement(styles$j.TextContainer, null, backButtonText))) : React__default.createElement(backLink.BackLink, { backLinkText: backButtonText })));
};

exports.BackButton = BackButton;
